import Vue from "vue";
import Router from "vue-router";

import Login from "./views/Login.vue";
import Users from "./views/Users.vue";
import Factories from "./views/Factories.vue";
import Dashboard from "./views/Dashboard.vue";
import RightGroups from "./views/RightGroups.vue";
import Categories from "./views/Categories.vue";
import Products from "./views/Products.vue";
import MyStocks from "./views/MyStocks.vue";
import SettingsPage from "./views/Settings.vue";
import MyOrders from "./views/MyOrders.vue";
import Feedback from "./views/Feedback.vue";
import Imports from "./views/Imports";

import Report_Orders from "./views/reports/Orders.vue";
import Report_LazyUsers from "./views/reports/LazyUsers.vue";
import Report_LastStockUpdate from "./views/reports/LastStockUpdate.vue";
import Report_UnorderedProducts from "./views/reports/UnorderedProducts.vue";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(Router);
Vue.use(BootstrapVue);

export default new Router({
	routes: [
		{
			path: "/",
			name: "login",
			component: Login
		},
		{
			path: "/dashboard",
			name: "dashboard",
			component: Dashboard
		},
		{
			path: "/users",
			name: "users",
			component: Users
		},
		{
			path: "/factories",
			name: "factories",
			component: Factories
		},
		{
			path: "/right-groups",
			name: "right-groups",
			component: RightGroups
		},
		{
			path: "/product-categories",
			name: "product-categories",
			component: Categories
		},
		{
			path: "/products",
			name: "products",
			component: Products
		},
		{
			path: "/my-stocks",
			name: "my-stocks",
			component: MyStocks
		},
		{
			path: "/settings",
			name: "settings",
			component: SettingsPage
		},
		{
			path: "/my-orders",
			name: "my-orders",
			component: MyOrders
		},
		{
			path: "/reports-orders",
			name: "reports-orders",
			component: Report_Orders
		},
		{
			path: "/imports",
			name: "imports",
			component: Imports
		},
		{
			path: "/reports-lazy-users",
			name: "reports-lazy-users",
			component: Report_LazyUsers
		},
		{
			path: "/feedback/:id",
			name: "feedback",
			component: Feedback
		},
		{
			path: "/reports-last-stock-update",
			name: "Report_LastStockUpdate",
			component: Report_LastStockUpdate
		},
		{
			path: "/report-unordered-products",
			name: "Report_UnorderedProducts",
			component: Report_UnorderedProducts
		}
	]
});
